import React from 'react'

import { GridFlex } from '@utils/Containers'
import { HEADING_COLOR_LIGHT, TEXT_COLOR_LIGHT } from './constants'
import { fontSizes } from '@utils/Typography'
import styled from 'styled-components'
import { NavigationMenu } from '@base-ui/react/navigation-menu'
import { Link as GatsbyLink } from 'gatsby'
import { space, layout, color } from 'styled-system'
import shouldForwardProp from '@styled-system/should-forward-prop'

const StyledNav = styled('nav').withConfig({ shouldForwardProp })(
  {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 16,
    boxShadow: '0 15px 25px -2px rgba(0,0,0,0.2)',
    minWidth: 200
  },
  space,
  layout,
  color
)

const StyledList = styled.ul({
  listStyle: 'none',
  margin: 0,
  padding: 0
})

const StyledLinkWrapper = styled.div({
  display: 'block',
  padding: 8,
  fontSize: fontSizes.body,
  color: 'inherit',
  textDecoration: 'none',
  transition: 'background-color 100ms ease-out',
  borderRadius: 8,

  '&:hover': {
    backgroundColor: 'rgba(42, 69, 76, 0.08)'
  },
  '& a': {
    display: 'block',
    color: 'inherit',
    textDecoration: 'none'
  }
})

const NavLink = ({
  href,
  external,
  closeOnClick = true,
  children,
  ...props
}) => {
  if (external) {
    return (
      <NavigationMenu.Link
        href={href}
        closeOnClick={closeOnClick}
        render={linkProps => <a {...linkProps} rel="noopener" />}
        {...props}
      >
        {children}
      </NavigationMenu.Link>
    )
  }
  return (
    <NavigationMenu.Link
      href={href}
      closeOnClick={closeOnClick}
      render={linkProps => {
        const { href: to, ...rest } = linkProps
        return <GatsbyLink to={to} {...rest} />
      }}
      {...props}
    >
      {children}
    </NavigationMenu.Link>
  )
}

const LEARN_LINKS = [
  {
    key: 'learn--support',
    href: '/support/',
    label: 'Support',
    description: 'Get help with our apps'
  },
  {
    key: 'learn--flow-gallery',
    href: '/flow/gallery/',
    label: 'Flow Gallery',
    description: 'Flow examples and inspiration'
  },
  {
    key: 'learn--articles',
    href: '/articles',
    label: 'Articles',
    description: 'Read our latest articles and guides'
  }
]

export const LearningContent = ({
  // imageData,
  px = 3,
  py = 3,
  gap = 1,
  // theme,
  ...props
}) => {
  // const headingColor =
  //   theme === 'light' ? HEADING_COLOR_LIGHT : HEADING_COLOR_DARK
  // const textColor = theme === 'light' ? TEXT_COLOR_LIGHT : TEXT_COLOR_DARK

  return (
    <StyledNav px={px} py={py} {...props} gap={gap} width="100%" bg="#fff">
      <StyledList>
        {LEARN_LINKS.map(({ key, href, label, description }) => {
          return (
            <li key={key}>
              <StyledLinkWrapper>
                <NavLink href={href}>
                  <GridFlex flexDirection="column" gap={1}>
                    <GridFlex
                      as="span"
                      fontWeight="600"
                      color={HEADING_COLOR_LIGHT}
                    >
                      {label}
                    </GridFlex>
                    <GridFlex as="span" color={TEXT_COLOR_LIGHT}>
                      {description}
                    </GridFlex>
                  </GridFlex>
                </NavLink>
              </StyledLinkWrapper>
            </li>
          )
        })}
      </StyledList>
    </StyledNav>
  )
}
